// extracted by mini-css-extract-plugin
export default {"fill":"fill---HtKSX","iconStart":"iconStart---FVecr","iconEnd":"iconEnd---E9osy"};